/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */
import { UIGroup } from "../../../../core/ui/index.js";
export class FileBrowserFiles extends UIGroup {
    className() {
        return 'FileBrowserFiles';
    }
}
